import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faLanguage,
  faAngleDoubleLeft,
} from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import Breadcrumbs from "../../Navigation/Components/Breadcrumbs";
import TrainingRequestSelectedPerson from "./TrainingRequestSelectedPerson";
import TrainingRequestPoolPerson from "./TrainingRequestPoolPerson";
import { useTranslation } from "react-i18next";
import "./NewTrainingRequestForm.css";

function NewTrainingRequestForm() {
  const [name, setName] = useState("");
  const [nameEnglish, setNameEnglish] = useState("");
  const [provider, setProvider] = useState("");
  const [cost, setCost] = useState(0);
  const [english, setEnglish] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [training, setTraining] = useState(null);
  const [trainings, setTrainings] = useState([]);
  const [selectedPeople, setSelectedPeople] = useState([]);
  const [people, setPeople] = useState([]);
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(null);

  const navigate = useNavigate();

  const { state } = useContext(AuthContext);

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/formData/${state.organization}`,
        data: { language: state.language, userId: state.userId },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });

      setPeople(response.data.users);
      setTrainings(response.data.trainings);
      setGroups(response.data.trainingGroups);

      if (state.language === "en") {
        setEnglish(true);
      } else {
        setEnglish(false);
      }
      setIsLoading(false);
    }
    fetch();
  }, [state.language, state.organization, state.token, state.userId]);

  const activateEnglish = () => {
    setEnglish(true);
  };

  const handleSubmit = async () => {
    try {
      await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/trainingRequests/new`,
        data: {
          name: name,
          name_english: nameEnglish,
          provider: provider,
          cost: cost,
          users: selectedPeople,
          organization: state.organization,
          requester_id: state.userId,
          training_id: training,
          group: group,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      navigate("/trainings/requests");
    } catch (error) {
      console.log(error.response.data);
    }
  };

  const handleTrainingChange = (e) => {
    setTraining(e.id);
  };

  const handleProviderChange = (e) => {
    setProvider(e.target.value);
  };

  const handleCostChange = (e) => {
    setCost(e.target.value);
  };

  const handleNameEnglishChange = (e) => {
    setNameEnglish(e.target.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleGroupChange = (e) => {
    setGroup(e.id);
  };

  const handleSelection = (id) => {
    let buffer = people.find((element) => element._id === id);

    let newPeopleArray = people.filter((element) => {
      return element._id !== id;
    });

    setSelectedPeople([...selectedPeople, buffer]);
    setPeople(newPeopleArray);
  };

  const handleBackToPool = (id) => {
    let buffer = selectedPeople.find((element) => element._id === id);

    let newSelectedPeopleArray = selectedPeople.filter((element) => {
      return element._id !== id;
    });

    setPeople([...people, buffer]);
    setSelectedPeople(newSelectedPeopleArray);
  };

  const handleMassiveSelection = () => {
    setSelectedPeople([...selectedPeople, ...people]);
    setPeople([]);
  };

  let breadcrumbs = [
    {
      title: state.language === "es" ? "Capacitaciones" : "Trainings",
      path: "/trainings",
    },
  ];

  if (isLoading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row>
          <Breadcrumbs data={breadcrumbs} />
        </Row>
        <Row>
          <Col lg={11} className="new-training-header">
            <h2>
              {t("Capacitaciones.SolicitudesCapacitacion.NewForm.Titulo")}
            </h2>
          </Col>
          <Col lg={1} className="new-scale-header mb-2">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={activateEnglish}>
                  <FontAwesomeIcon icon={faLanguage} /> English
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col lg={8}>
            <Form>
              <Col className="new-training-request-form mb-3">
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t(
                      "Capacitaciones.SolicitudesCapacitacion.NewForm.SeleccionarCapacitacion"
                    )}
                  </Form.Label>
                  <Select
                    onChange={(e) => handleTrainingChange(e)}
                    options={trainings}
                    placeholder={t(
                      "Capacitaciones.SolicitudesCapacitacion.NewForm.SeleccionarCapacitacion"
                    )}
                  />
                </Form.Group>
                {training === "none" && state.language === "es" ? (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Nombre"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Nombre"
                      )}
                      onChange={handleNameChange}
                    />
                  </Form.Group>
                ) : (training === "none" && state.language === "en") ||
                  (training === "none" && english) ? (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Nombre"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Nombre"
                      )}
                      onChange={handleNameEnglishChange}
                    />
                  </Form.Group>
                ) : (
                  <></>
                )}
                {training === "none" ? (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Proveedor"
                      )}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Proveedor"
                      )}
                      onChange={handleProviderChange}
                    />
                  </Form.Group>
                ) : (
                  <></>
                )}
                {training === "none" ? (
                  <Form.Group className="mb-3">
                    <Form.Label>
                      {t("Capacitaciones.SolicitudesCapacitacion.NewForm.Tipo")}
                    </Form.Label>
                    <Select
                      onChange={(e) => handleGroupChange(e)}
                      options={groups}
                      placeholder={t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.Seleccionar"
                      )}
                    />
                  </Form.Group>
                ) : (
                  <></>
                )}
                <Form.Group className="mb-3">
                  <Form.Label>
                    {t("Capacitaciones.SolicitudesCapacitacion.NewForm.Costo")}
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder={t(
                      "Capacitaciones.SolicitudesCapacitacion.NewForm.Costo"
                    )}
                    onChange={handleCostChange}
                  />
                </Form.Group>
              </Col>
              <Col className="training-request-selected-people">
                <Col>
                  <h6>
                    {t(
                      "Capacitaciones.SolicitudesCapacitacion.NewForm.Personas"
                    )}
                  </h6>
                </Col>
                {selectedPeople.length === 0 ? (
                  <Col className="text-center mb-4 mt-4">
                    <h6 className="no-people-selected">
                      No hay personas seleccionadas, agrega desde el panel a la
                      derecha.
                    </h6>
                  </Col>
                ) : (
                  <></>
                )}
                <Col>
                  {selectedPeople.map((element) => (
                    <TrainingRequestSelectedPerson
                      key={element._id}
                      id={element._id}
                      firstName={element.firstName}
                      lastName={element.lastName}
                      profile={element.profileName}
                      handleBackToPool={handleBackToPool}
                    />
                  ))}
                </Col>
              </Col>
              <Col>
                <Button className="primary" onClick={handleSubmit}>
                  {t("Capacitaciones.SolicitudesCapacitacion.NewForm.Guardar")}
                </Button>
                <Link to="/trainings/requests">
                  <Button className="danger">
                    {t(
                      "Capacitaciones.SolicitudesCapacitacion.NewForm.Cancelar"
                    )}
                  </Button>
                </Link>
              </Col>
            </Form>
          </Col>
          <Col lg={4}>
            <Col className="training-request-people-pool">
              <Col>
                <Row className="justify-content-left align-items-center">
                  <Col lg={11}>
                    <h6>
                      {t(
                        "Capacitaciones.SolicitudesCapacitacion.NewForm.PersonasDisponibles"
                      )}
                    </h6>
                  </Col>
                  <Col lg={1}>
                    <FontAwesomeIcon
                      icon={faAngleDoubleLeft}
                      onClick={handleMassiveSelection}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                {people.map((element) => (
                  <TrainingRequestPoolPerson
                    key={element._id}
                    id={element._id}
                    firstName={element.firstName}
                    lastName={element.lastName}
                    profile={element.profileName}
                    handleSelection={handleSelection}
                  />
                ))}
              </Col>
            </Col>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default NewTrainingRequestForm;
